























import {
  Component,
  Vue,
  Watch,
} from 'vue-property-decorator';
import Overlay from '@/components/common/overlay.vue';
import { ContentModuleMapper } from '@/store/modules/content';
import { MenuModuleMapper } from '@/store/modules/menu';
import { SidebarModuleMapper } from '@/store/modules/sidebar';
import { ConfigsModuleMapper } from '@/store/modules/config';
import ItemResolver from './itemResolver.vue';

const Mappers = Vue.extend({
  computed: MenuModuleMapper.mapGetters(['parentExpanded', 'itemsList', 'menuIsLoaded']),
  methods: {
    ...ConfigsModuleMapper.mapMutations({
      setFromSearch: 'setFromSearch',
    }),
    ...ContentModuleMapper.mapActions({
      preloadPage: 'preloadPage',
    }),
    ...MenuModuleMapper.mapMutations({
      toggleItemExpanded: 'toggleItemExpanded',
    }),
    ...SidebarModuleMapper.mapMutations({
      toggle: 'toggle',
    }),
  },
});

@Component({
  name: 'SideBarMenuItemComponent',
  components: {
    Overlay,
    ItemResolver,
  },
  props: {
    item: Object,
    innerWidth: Number,
    expanded: Boolean,
  },
})
export default class SideBarMenuItemComponent extends Mappers {
  classes = 'collapse';

  height = `${0}px`;

  get baseUrl() {
    return (this.$router as any).options.base.length > 1 ? (this.$router as any).options.base : '';
  }

  get menu() {
    return this.itemsList(this.$props.item.label, this.$props.item.type);
  }

  itemIsSelected(url: string): boolean {
    return this.$route.path !== `${url}`;
  }

  updated() {
    Vue.nextTick(() => {
      this.checker();
    });
  }

  checker() {
    (this.$refs.counter as HTMLElement).classList.remove('calculated');
  }

  mounted() {
    if (this.$props.item.expanded) {
      this.classes = 'collapse in';
      this.height = 'auto';
    }
    Vue.nextTick(() => {
      this.checker();
    });
  }

  @Watch('innerWidth')
  innerWidthChanged() {
    if (this.$props.expanded || this.parentExpanded(this.$props.item.label)) {
      if (window.innerWidth > 1279) {
        this.height = 'auto';
      } else if (window.innerWidth < 1280 && window.innerWidth > 767) {
        const aside = document.querySelector('.aside-holder');
        const asideHeight = aside ? aside.clientHeight : 0;
        this.height = `${asideHeight + 78}px`;
      } else {
        this.height = 'auto';
      }
    }
  }

  @Watch('expanded')
  expandedChanged(newVal: any, oldVal: any) {
    if (newVal !== oldVal) {
      if (window.innerWidth > 1279) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        if (newVal) {
          self.classes = 'collapsing';
          setTimeout(() => {
            let height = 0;
            (this.$refs.item as HTMLHtmlElement).querySelectorAll('.collapsing > .section-scroller > ul > li').forEach((item: Element) => {
              height += item.clientHeight;
            });
            self.height = `${height}px`;
          }, 1);
          setTimeout(() => {
            self.classes = 'collapse in';
            self.height = 'auto';
          }, 350);
        } else {
          self.classes = 'collapsing';
          self.height = `${0}px`;
          setTimeout(() => {
            self.classes = 'collapse';
          }, 350);
        }
      } else if (window.innerWidth < 1280 && window.innerWidth > 767) {
        const aside = document.querySelector('.aside-holder');
        const asideHeight = aside ? aside.clientHeight : 0;
        if (newVal) {
          this.classes = 'collapse in';
          this.height = `${asideHeight + 78}px`;
        } else {
          this.classes = 'collapse';
          this.height = `${0}px`;
        }
      } else if (newVal) {
        this.classes = 'collapse in';
        this.height = 'auto';
      } else {
        this.classes = 'collapse';
        this.height = `${0}px`;
      }
    }
  }

  click(event: Event, skipToggle: boolean) {
    event.preventDefault();
    const isExpanded = !this.$props.item.expanded;
    if (!skipToggle) {
      this.toggleItemExpanded({ label: this.$props.item.label, state: !this.$props.item.expanded });
    } else {
      this.toggleItemExpanded({ label: this.$props.item.label, state: true });
    }
    if (isExpanded || skipToggle) {
      if (this.$route.path !== `${this.$props.item.url}`) {
        if (window.innerWidth > 1279) {
          if (this.$props.item.hasContent) {
            this.goTo(`${this.$props.item.url}`);
          } else if (this.menu.length) {
            const [firstChild] = this.menu;
            if ((firstChild as any).url) {
              this.toggleItemExpanded({
                label: (firstChild as any).label,
                state: !(firstChild as any).expanded,
              });
              if (this.$route.path !== `${(firstChild as any).url}`) {
                this.goTo(`${(firstChild as any).url}`);
              }
            }
          } else if (!this.$props.item.hasContent && !this.menu.length && this.$props.item.url && this.$props.item.url.length) {
            this.goTo(`${this.$props.item.url}`);
          }
        } else if (!this.menu.length || skipToggle) {
          this.toggle(false);
          this.goTo(`${this.$props.item.url}`);
        }
      }
    }
  }

  goTo(url: string) {
    this.setFromSearch(false);
    this.$router
      .push(url)
      .catch(() => {
        // ToDo remove in next iteration
        // console.warn('goto', e);
      });
  }

  closeParent(event: Event) {
    event.preventDefault();
    this.toggleItemExpanded({ label: this.$props.item.label, state: false });
  }
}
